import React from "react";

const BoldFormatter = ({ value }) => <span style={{ fontWeight: "bold" }}>{value}</span>;

export const BrandTypeProvider = props => (
  <props.DataTypeProvider formatterComponent={({ value }) => <BoldFormatter value={value} />} {...props} />
);

export const ModelTypeProvider = props => (
  <props.DataTypeProvider formatterComponent={({ value }) => <BoldFormatter value={value} />} {...props} />
);
